// ============================================
// ValueAreaSettingsMenu.jsx
// Settings popup for the Volume Profile Value Area overlay (POC / VAH / VAL
// + band). Shared menu shell (menu/ChartMenu): frame, fit, outside-click /
// Esc and styles. Colours use the shared ColorPicker like every other
// indicator menu. (VP bar colours live in the Volume Profile menu —
// right-click the bars.)
//
// config shape (owned by the chart, edited here; other keys pass through):
//   { vaPct, showPOC, showBounds, showBand, pocColor, bandColor, weight }
// ============================================
import ChartMenu, { MenuRow, MenuSelect, MenuToggle, MenuSwatch, MenuWeight, MenuDivider } from './menu/ChartMenu'

const VA_PCTS   = [68, 70, 80].map(p => ({ value: p, label: `${p}%` }))
const WEIGHTS   = [1, 2, 3, 4]

export default function ValueAreaSettingsMenu({ show, x, y, openLeft, config, onUpdate, onClose }) {
  // Live edits, like the other indicator menus: every change goes straight to
  // the chart (no draft copy, no APPLY). Click outside or Escape closes.
  if (!show) return null

  const cfg = config
  const set = (patch) => onUpdate({ ...config, ...patch })

  return (
    <ChartMenu anchor={{ x, y }} openLeft={openLeft} onClose={onClose}>
      {/* VALUE AREA — % + which markers */}
      <MenuRow label={<>Value&nbsp;Area</>}>
        <MenuSelect value={cfg.vaPct} options={VA_PCTS} renderValue={() => `${cfg.vaPct}%`}
          onChange={(p) => set({ vaPct: p })} />
        <MenuDivider />
        <MenuToggle on={cfg.showPOC} onChange={() => set({ showPOC: !cfg.showPOC })}>{cfg.showPOC ? '✓' : '○'} POC</MenuToggle>
        <MenuToggle on={cfg.showBounds} onChange={() => set({ showBounds: !cfg.showBounds })}>{cfg.showBounds ? '✓' : '○'} VAH/VAL</MenuToggle>
        <MenuToggle on={cfg.showBand} onChange={() => set({ showBand: !cfg.showBand })}>{cfg.showBand ? '✓' : '○'} Band</MenuToggle>
      </MenuRow>

      {/* LINE STYLE — POC colour, band colour, weight */}
      <MenuRow label="Lines">
        <MenuSwatch value={cfg.pocColor} onChange={(c) => set({ pocColor: c })} title="POC colour" />
        <MenuDivider />
        <MenuSwatch value={cfg.bandColor} onChange={(c) => set({ bandColor: c })} title="VAH/VAL + band colour" />
        <MenuDivider />
        <MenuWeight value={cfg.weight} weights={WEIGHTS} onChange={(w) => set({ weight: w })} />
      </MenuRow>
    </ChartMenu>
  )
}
